import React from 'react';
import PropTypes from 'prop-types';

import logo from '../../../img/cc-logo-2022-white.svg';
import { Link } from 'react-router-dom';

const CODE_VERIFIER = /[0-9]{6}/;

export default class ForgotPassword extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);

		let isAccountReset = false;
		let verificationCode = '';
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('vcode')) {
			const vcode = urlParams.get('vcode');
			if (CODE_VERIFIER.test(vcode)) {
				isAccountReset = true;
				verificationCode = vcode;
			}
		}

		this.state = {
			isAccountReset,
			password1: '',
			password2: '',
			email: '',
			verificationCode,
			passwordReset: false,
		};
	}

	findPassword = (event) => {
		event.preventDefault();
		const { email } = this.state;
		this.props.user.set({ email });
		this.props.user
			.forgotPassword()
			.always(() => this.setState({ isAccountReset: true }));
	};

	handleEmailChange = ({ target }) => {
		this.setState({ email: target.value });
	};

	handleVerificationCodeChange = ({ target }) => {
		this.setState({ verificationCode: target.value });
	};

	handlePassword1Change = ({ target }) => {
		this.setState({ password1: target.value });
	};

	handlePassword2Change = ({ target }) => {
		this.setState({ password2: target.value });
	};

	resetPassword = (event) => {
		const { verificationCode, email, password1 } = this.state;
		event.preventDefault();
		this.setState({ isError: false, isUnknownError: false });
		this.props.user.resetPassword(verificationCode, email, password1).then(
			({ cb }) => {
				if (cb && cb.password_reset === 'successful') {
					this.setState({ passwordReset: true });
				} else {
					this.setState({ isError: true });
				}
			},
			() => {
				// unknown error
				this.setState({
					isUnknownError: true,
				});
			}
		);
	};

	render() {
		const {
			email,
			verificationCode,
			password1,
			password2,
			passwordReset,
			isError,
			isUnknownError,
		} = this.state;

		const panelContent = this.state.isAccountReset ? (
			<form onSubmit={this.resetPassword}>
				<div className="form-group has-feedback">
					<label htmlFor="inputEmail">Email address</label>
					<input
						type="email"
						id="inputEmail"
						className="form-control email"
						required
						autoFocus
						autoComplete="email"
						value={email}
						onChange={this.handleEmailChange}
					/>
					<span className="fa fa-envelope form-control-feedback text-muted" />
				</div>
				<div className="form-group has-feedback">
					<label htmlFor="verificationCode">Verification code</label>
					<input
						type="text"
						id="verificationCode"
						className="form-control verification-code"
						required
						autoComplete="one-time-code"
						value={verificationCode}
						onChange={this.handleVerificationCodeChange}
					/>
					<span className="fa fa-key form-control-feedback text-muted" />
				</div>
				<div className="form-group has-feedback">
					<label htmlFor="inputPassword1">Password</label>
					<input
						type="password"
						className="form-control password"
						required="required"
						autoComplete="new-password"
						onChange={this.handlePassword1Change}
						value={password1}
						id="inputPassword1"
					/>
					<span className="fa fa-lock form-control-feedback text-muted"></span>
				</div>
				<div className="form-group has-feedback">
					<label htmlFor="inputPassword2">Confirm Password</label>
					<input
						type="password"
						className="form-control password"
						required="required"
						autoComplete="new-password"
						onChange={this.handlePassword2Change}
						value={password2}
						id="inputPassword2"
					/>
					<span className="fa fa-lock form-control-feedback text-muted"></span>
				</div>
				<button className="btn btn-danger btn-block" type="submit">
					Change Password
				</button>
			</form>
		) : (
			<form onSubmit={this.findPassword}>
				<p className="text-center">
					Enter the associated email address for the account and click Reset to
					receive a verification code via SMS Text on your cell phone and email.
				</p>
				<p className="text-center">
					<strong>Note:</strong> a valid cell phone number with SMS capability
					must be on file to receive the SMS Text.
				</p>
				<div className="form-group has-feedback">
					<label htmlFor="inputEmail">Email address</label>
					<input
						type="email"
						id="inputEmail"
						className="form-control email"
						value={email}
						placeholder="Email address"
						required
						autoFocus
						autoComplete="off"
						onChange={this.handleEmailChange}
					/>
					<span className="fa fa-envelope form-control-feedback text-muted" />
				</div>
				<button className="btn btn-danger btn-block" type="submit">
					Reset
				</button>
			</form>
		);

		return (
			<div className="main block-center mt-xl wd-xl">
				<div className="panel panel-dark panel-flat">
					<div className="panel-heading text-center">
						<Link to="/">
							<img src={logo} />
						</Link>
					</div>
					<div className="panel-body">
						<h4 className="text-center pv">Password Reset</h4>
						{isError && (
							<p className="text-center text-danger">
								An error occurred while attempting to set your password, please
								try again later. If problem persists, please contact support.
							</p>
						)}
						{isUnknownError && (
							<p className="text-center text-danger">
								An error occurred while attempting to set your password. Please
								contact support.
							</p>
						)}
						{passwordReset ? (
							<div className="message">
								<p className="text-center">Your password has been changed.</p>
								<p className="text-center">
									<Link to="/">Return to the home page to login.</Link>
								</p>
							</div>
						) : (
							panelContent
						)}
					</div>
				</div>
			</div>
		);
	}
}
